// 260812nrai: Urlaubsantrag modal + journal workflow filter

function populateVacationLeadSelect(leads, selectedEmployeeId) {
  const $select = $('#vacation_request_lead_select');
  const $receiver = $('#vacation_request_receiver');
  $select.empty();

  (leads || []).forEach((lead) => {
    const option = $('<option></option>')
      .val(String(lead.employee_id))
      .text(lead.receiver_name || '');
    $select.append(option);
  });

  const selectedId = selectedEmployeeId || (leads && leads.length ? leads[0].employee_id : null);
  if (selectedId) {
    $select.val(String(selectedId));
  }

  const showPicker = (leads || []).length > 1;
  if (showPicker) {
    $receiver.hide().text('');
    $select.show();
  } else {
    const singleLead = (leads || [])[0];
    $receiver.text(singleLead ? (singleLead.receiver_name || '') : '').show();
    $select.hide();
  }

  $('#vacation_request_lead_employee_id').val($select.val() || (selectedId ? String(selectedId) : ''));
}

function showVacationRequestToast(message, kind) {
  if (window.toast_manager && typeof window.toast_manager.push_many === 'function') {
    window.toast_manager.push_many([{
      kind: kind || 'success',
      html: message,
      duration_ms: 5000
    }]);
    return;
  }
  const $zone = $('#flash_zone');
  if ($zone.length) {
    $zone.html(`<div class="flash ${kind === 'error' ? 'error' : 'notice'}">${message}</div>`);
  }
}

function vacationRequestFieldsValid() {
  const von = ($('#vacation_request_von').val() || '').trim();
  const bis = ($('#vacation_request_bis').val() || '').trim();
  if (von && bis) {
    $('#vacation_request_error').hide().text('');
    return true;
  }
  const missing = [];
  if (!von) { missing.push('Von'); }
  if (!bis) { missing.push('Bis'); }
  $('#vacation_request_error')
    .text(`Es fehlen notwendige Angaben: ${missing.join(', ')}.`)
    .show();
  return false;
}

export function vacationRequestOpen(el) {
  const $el = $(el);
  const timeRecordId = $el.data('time-record-id') || $el.attr('data-time_record_id');
  const modal = $('#vacation_request_modal');
  if (!timeRecordId || !modal.length) { return false; }

  $('#vacation_request_error').hide().text('');
  $('#vacation_request_send').addClass('disabled');

  $.post('/time_records/vacation_request_form', {
    id: timeRecordId,
    current_step_id: $el.data('current-step-id') || $el.attr('data-current_step_id'),
    next_step_id: $el.data('next-step-id') || $el.attr('data-next_step_id')
  })
    .done((data) => {
      if (data && data.success === false) {
        showVacationRequestToast('Kein Empfänger mit Freigabe-Berechtigung gefunden.', 'error');
        return;
      }
      populateVacationLeadSelect(data.leads || [], data.lead_employee_id);
      $('#vacation_request_von').val(data.von || '');
      $('#vacation_request_bis').val(data.bis || '');
      $('#vacation_request_time_record_id').val(data.time_record_id || timeRecordId);
      $('#vacation_request_current_step_id').val(data.current_step_id || '');
      $('#vacation_request_next_step_id').val(data.next_step_id || '');
      $('#vacation_request_send').removeClass('disabled');
      modal.foundation('reveal', 'open');
    })
    .fail(() => {
      showVacationRequestToast('Der Urlaubsantrag konnte nicht geöffnet werden.', 'error');
    });
  return false;
}

function sendVacationRequest() {
  if (!vacationRequestFieldsValid()) { return; }

  const payload = {
    id: $('#vacation_request_time_record_id').val(),
    time_record_id: $('#vacation_request_time_record_id').val(),
    lead_employee_id: $('#vacation_request_lead_employee_id').val() || $('#vacation_request_lead_select').val(),
    von: ($('#vacation_request_von').val() || '').trim(),
    bis: ($('#vacation_request_bis').val() || '').trim(),
    current_step_id: $('#vacation_request_current_step_id').val(),
    next_step_id: $('#vacation_request_next_step_id').val()
  };

  $('#vacation_request_error').hide().text('');
  $('#vacation_request_send').addClass('disabled');

  $.post('/time_records/vacation_request_send', payload)
    .done((data) => {
      $('#vacation_request_modal').foundation('reveal', 'close');
      if (data.message) {
        showVacationRequestToast(data.message, 'success');
      }
      if (typeof window.ajax_refresh_journal === 'function' && window.ajax_refresh_journal()) {
        // journal list reloaded (hatch, this_step, next_step)
      } else if (data.workflow_html && data.time_record_id) {
        $(`#time_record_workflow_${data.time_record_id}`).replaceWith(data.workflow_html);
      }
    })
    .fail(() => {
      $('#vacation_request_send').removeClass('disabled');
      showVacationRequestToast('Der Urlaubsantrag konnte nicht gesendet werden.', 'error');
    });
}

export function filter_time_record_workflow(taskId, workflowCode, workflowStep) {
  if (typeof SetPageToBusy === 'function') { SetPageToBusy(); }
  if ($('#time_records_journal').length) { dimmed_element('#time_records_journal', 'show'); }
  $.post('/time_records/ajax_filter_workflow', {
    lookup_focus: 'workflow_step',
    task_id: taskId,
    workflow_code: workflowCode,
    workflow_step: workflowStep,
    employee: $('#record_employee_id').val(),
    institution: $('#institution').val() || [],
    task_type_ids: $('#task_type_ids').val() || [],
    von: $('#record_von').val() || (($('#von_date').val() || '') + ' 00:00:00')
  }).always(function () {
    if (typeof SetPageToIdle === 'function') { SetPageToIdle(); }
  });
  return false;
}

export function initVacationRequest() {
  $(document).on('change', '#vacation_request_lead_select', function () {
    $('#vacation_request_lead_employee_id').val($(this).val() || '');
  });
  $(document).on('click', '#vacation_request_send', function () {
    if ($(this).hasClass('disabled')) { return; }
    sendVacationRequest();
  });
  $(document).on('click', '.vacation_request_cancel', function () {
    $('#vacation_request_modal').foundation('reveal', 'close');
  });
}

window.vacationRequestOpen = vacationRequestOpen;
window.filter_time_record_workflow = filter_time_record_workflow;
